// Vuex canvas store module
import penProperty from './penProperty'

const state = {
  canvasActive: true
}

const getters = {
  canvasActive: state => state.canvasActive
}

const mutations = {
}

const actions = {
}

export default {
  namespaced : true,
  state,
  getters,
  actions,
  mutations,
  modules    : {
    penProperty
  }
}



// WEBPACK FOOTER //
// ./src/components/canvas/store/index.js